import { useMemo } from 'react'
import { MoneyCashModal } from 'refunds/components/MoneyCashModal/MoneyCashModal'
import { MoneyCashFormContainer } from 'refunds/containers/MoneyCashFormContainer/MoneyCashFormContainer'
import { UniversalBankContainer } from 'refunds/containers/UniversalBankContainer/UniversalBankContainer'
import type {
	MoneyCashInfo,
	RefundData,
	VisibilityProps,
} from 'refunds/types/refundData'
import { PageType } from 'types/analytics'

interface MoneyCashContainerProps {
	readonly onChangeFormVisibility: (showForm: boolean) => void
	readonly handleRequestStatus: (status: string) => void
	readonly handleOnSubmit?: (values: MoneyCashInfo) => void
	readonly reloadRefundData?: () => void
	readonly showNotification?: () => void
	readonly pageType: PageType
	readonly refundData: RefundData
	readonly visibilityProps: VisibilityProps
}

export function MoneyCashContainer(props: MoneyCashContainerProps) {
	const {
		refundData: { moneyCash },
		pageType,
		visibilityProps,
	} = props
	const { moneyCashInfo } = moneyCash ?? {}
	const { forceShowMoneyCashForm } = visibilityProps

	const cardContent = useMemo(() => {
		if (!moneyCashInfo) {
			return null
		}

		const { mobile } = moneyCashInfo
		return mobile && <span>{mobile}</span>
	}, [moneyCashInfo])

	return (
		<UniversalBankContainer
			{...props}
			title={moneyCashInfo?.owner}
			CardContent={cardContent}
			FormContainer={MoneyCashFormContainer}
			ModalComponent={MoneyCashModal}
			showDirectForm={pageType === PageType.Refunds && forceShowMoneyCashForm}
		/>
	)
}
